let fstId = Math.floor(Math.random()*100 +1)

export default [
    {
        id: fstId,
        value: "?",
        fixed: false
    },
    {
        id: ++fstId,
        value: "?",
        fixed: false
    },
    {
        id: ++fstId,
        value: "?",
        fixed: false
    },
    {
        id: ++fstId,
        value: "?",
        fixed: false
    },
    {
        id: ++fstId,
        value: "?",
        fixed: false
    },
    {
        id: ++fstId,
        value: "?",
        fixed: false
    },
    {
        id: ++fstId,
        value: "?",
        fixed: false
    },
    {
        id: ++fstId,
        value: "?",
        fixed: false
    },
    {
        id: ++fstId,
        value: "?",
        fixed: false
    },
    {
        id: ++fstId,
        value: "?",
        fixed: false
    },

]